/**
 * @desc 新增/修改
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.CenterCountyMappingRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/centerCountyMapping/saveOrUpdate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
